import type { Suggestion } from '../types';

export function getUniqueSuggestionId(suggestion: Suggestion) {
  return `${suggestion.elementId}-${suggestion.pageId}-${suggestion.id}`;
}
